// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-chip {
  display: flex;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 16px;
  border: 1px solid var(--gray_light2);
  border-radius: 24px;
  font-size: 12px;
  color: var(--color_neutral_900);
}
.context-chip svg {
  color: var(--color_neutral_800);
}
.context-chip.with-icon {
  padding-left: 12px;
}
.context-chip.with-close {
  padding-right: 12px;
}
.context-chip.active {
  border-color: var(--color_primary_500);
}
.context-chip.active svg {
  color: var(--color_primary_500);
}
.context-chip .close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/components/context-chip/context-chip.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AACF;AACE;EACE,+BAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,sCAAA;AAFJ;AAGI;EACE,+BAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAHJ","sourcesContent":[".context-chip {\n  display: flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px 16px;\n  border: 1px solid var(--gray_light2);\n  border-radius: 24px;\n  font-size: 12px;\n  color: var(--color_neutral_900);\n\n  svg {\n    color: var(--color_neutral_800);\n  }\n\n  &.with-icon {\n    padding-left: 12px;\n  }\n\n  &.with-close {\n    padding-right: 12px;\n  }\n\n  &.active {\n    border-color: var(--color_primary_500);\n    svg {\n      color: var(--color_primary_500);\n    }\n  }\n\n  .close-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    padding: 0;\n    border: none;\n    background: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
